import styled from 'styled-components';
import { NavBar } from '@app/src/common/header';
import { SIZE } from '@app/src/ui';

export const Wrapper = styled.div`
  position: sticky;
  z-index: 3000;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 1000;
`;

export const Content = styled.div`
  display: flex;
  background: #FAFAFA;
  align-items: center;
  justify-content: space-between;
  height: 56px;
  padding: 0 16px;

  @media (min-width: ${SIZE.TABLET_LANDSCAPE} ) {
    padding: 0 10px;
    height: 70px;
    box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.3);

    a {
      max-width: 275px;
    }
  }

  @media (min-width: ${SIZE.DESKTOP} ) {
    padding: 0 25px;
  }
`;

export const Menu = styled(NavBar)`
  display: none;

  @media(min-width: ${SIZE.TABLET_LANDSCAPE}) {
    display: flex;
  }
`;

const MAIN = 'HeaderSecondary';
Wrapper.displayName = `${MAIN}/Wrapper`;
Menu.displayName = `${MAIN}/Menu`;
